import { render, staticRenderFns } from "./WorkIconBack.vue?vue&type=template&id=2cc21cac"
import script from "./WorkIconBack.vue?vue&type=script&lang=js"
export * from "./WorkIconBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports